<template>
  <div
    ref="wrapperTemplateRef"
    :tabindex="0"
    :class="{ 'rounded-md ring-1 ring-inset ring-gray-300': !unstyled }"
    class="divide-y w-full"
  >
    <div
      :class="{ 'p-3 space-y-1 ': !unstyled }"
      class="text-gray-700 flex flex-col gap-1"
    >
      <div
        v-for="option in optionsWithKey"
        :key="option.key"
        :class="{ 'opacity-40': option.attrs?.disabled }"
        @click.stop.prevent="pickedValue = option.value"
      >
        <div
          :class="{
            'bg-gray-500': option.attrs?.disabled,
            'p-2 pr-2.5 rounded bg-blue-100': !unstyled,
          }"
          class="flex cursor-pointer"
        >
          <div class="flex items-center h-5">
            <n-radio
              :checked="pickedValue == option.value"
              :key="option.key"
              :value="option.value"
              :disabled="option.attrs?.disabled"
              @change="handleChange"
            />
          </div>
          <div class="ml-2 w-full text-sm cursor-pointer">
            <label :for="option.key" class="text-gray-900 cursor-pointer">
              <div>{{ option.label }}</div>
              <p
                id="helper-radio-text-4"
                class="text-xs font-normal text-gray-500 "
              >
                {{ option.subLabel }}
                <div v-if="option.duration" class='mt-1'>
                  {{ $t('Duration') }}:
                  <span v-if="Math.floor(option.duration / 60) > 0"
                    >{{ Math.floor(option.duration / 60) }}h</span
                  > <span v-if='option.duration % 60 > 0'>{{ option.duration % 60 }}m</span>
                </div>
              </p>
              <div
                class="flex grow w-full gap-1 items-center justify-between mb-0.5"
              >
                <div></div>
                <div class="flex flex-row gap-1">
                  <NTag class='cursor-pointer' size="small" round type="info" v-if="option.price > 0"
                    ><BanknotesIcon class="h-4 inline" /> {{ option.currency }}
                    {{ option.price }}
                    {{
                      option.pay_scheme === PayScheme.PER_SEAT
                        ? $t('per person')
                        : $t('per group')
                    }}
                  </NTag>
                  <NTag
                    v-for="language in option.languages"
                    class='cursor-pointer'
                    :key="language"
                    size="small"
                    round
                    type="primary"
                    >{{ language }}
                  </NTag>
                </div>
              </div>
            </label>
          </div>
        </div>
        <n-collapse-transition :show="pickedValue === option.value">
          <slot :selected-option="option" name="description" />
        </n-collapse-transition>
      </div>
    </div>
  </div>
  <div v-if="hasErrors" class="text-red-500">
    <div v-for="error of errors" :key="error.$uid" class="input-errors">
      <div class="error-msg">{{ error.$message }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { BanknotesIcon, ClockIcon } from '@heroicons/vue/24/outline'
import { PayScheme } from '../../types/PayScheme'
const props = defineProps<{
  modelValue?: string | number | null
  required?: boolean
  errors?: any[]
  unstyled?: boolean
  options: {
    label: string | number
    subLabel: string | number
    value: string | number
    attrs?: { disabled?: boolean }
  }[]
}>()
const emit = defineEmits(['update:modelValue', 'change'])
const wrapperTemplateRef = ref()
const optionsWithKey = computed(() =>
  props.options.map((option) => ({
    ...option,
    key:
      typeof option.value === 'number'
        ? option.value
        : option.value.split(' ').join(''),
  }))
)
const pickedValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('change')
    emit('update:modelValue', value)
  },
})
const hasErrors = computed(() => Boolean(props.errors?.length > 0))
const handleChange = (e: Event) => {
  pickedValue.value = (e.target as HTMLInputElement).value
}
defineExpose({
  wrapperTemplateRef,
})
</script>
